// src/components/Layout/Navigation.tsx
// Huvudnavigation för SireusCode

import React from 'react';
import { useAppContext } from '../../contexts/AppContext';
import LanguageSwitcher from '../UI/LanguageSwitcher';

const Navigation: React.FC = () => {
  const { state } = useAppContext();
  
  // Translation helper
  const t = (sv: string, en: string) => state.language === 'sv' ? sv : en;

  const navItems = [
    { 
      id: 'home', 
      label: t('Hem', 'Home'), 
      href: '#' 
    },
    { 
      id: 'about', 
      label: t('Om mig', 'About'), 
      href: '#about' 
    },
    { 
      id: 'services', 
      label: t('Tjänster', 'Services'), 
      href: '#services' 
    },
    {
      id: 'process',
      label: t('Process', 'Process'),
      href: '#process'
    },
    { 
      id: 'case-studies', 
      label: t('Uppdrag', 'Case Studies'), 
      href: '#case-studies' 
    },
    { 
      id: 'contact', 
      label: t('Kontakt', 'Contact'), 
      href: '#contact' 
    }
  ];

  const scrollToSection = (href: string) => {
    if (href === '#') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.querySelector(href);
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="sticky top-0 z-40 bg-white dark:bg-gray-900 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo/Namn */}
          <div className="font-bold text-xl text-gray-900 dark:text-white">
            Siréus Consulting
          </div>
          
          {/* Navigation items */}
          <div className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.href)}
                className="text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 font-medium transition-colors"
              >
                {item.label}
              </button>
            ))}
          </div>
          
          {/* Språkväljare */}
          <LanguageSwitcher variant="compact" />
        </div>
      </div>
    </nav>
  );
};

export default Navigation;